import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=1e6dbf44"
import script from "./YouTube.vue?vue&type=script&lang=js"
export * from "./YouTube.vue?vue&type=script&lang=js"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=1e6dbf44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports